/** Escapa texto pra entrar no HTML da janela de impressão. */
export const esc = (s: string | null | undefined) =>
  (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/**
 * Janela de impressão. Tem que ser aberta no clique, ANTES de qualquer `await`: abrir depois
 * perde o vínculo com o clique e o navegador bloqueia como pop-up. Devolve `escrever`, que monta a
 * página e manda imprimir — pode ser chamado depois de buscar os dados. Fecha sozinha depois de
 * imprimir: com impressão direta (atalho de etiquetas) as janelas se acumulariam a cada pedido.
 * O print é chamado daqui, não por `<script>` na janela: a `about:blank` herda a CSP do app, que
 * não aceita script inline.
 */
export function abrirImpressao(largura = 480, altura = 720) {
  const janela = window.open("", "_blank", `width=${largura},height=${altura}`);
  if (!janela) return null;
  janela.document.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>Preparando…</title></head>
<body style="font-family: Arial, Helvetica, sans-serif; color: #555; padding: 16px;">Preparando impressão…</body></html>`);
  return {
    escrever(titulo: string, css: string, corpo: string) {
      janela.document.open();
      janela.document.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8">
<title>${esc(titulo)}</title>
<style>* { box-sizing: border-box; } body { margin: 0; font-family: Arial, Helvetica, sans-serif; color: #000; } ${css}</style>
</head><body>${corpo}</body></html>`);
      janela.document.close();
      const imprimir = () => {
        janela.focus();
        janela.print();
        setTimeout(() => janela.close(), 500);
      };
      janela.onafterprint = () => janela.close();
      if (janela.document.readyState === "complete") imprimir();
      else janela.addEventListener("load", imprimir, { once: true });
    },
    fechar() {
      janela.close();
    },
  };
}
